import { Injectable } from '@angular/core';

import { TmsWebBaseCommentService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class StockItemCommentService extends TmsWebBaseCommentService {
  constructor() {
    super('StockItemComment');
  }
}
